module.exports = __webpack_public_path__ + "media/images/lb/900-8a8aab6c7cfc5913a91e27e9a59d54ce.svg";